






import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomLoading extends ComponentVue {
  @Prop({ type: Boolean })
  show!: boolean
}
